const deferredOnboardingPrefix = 'swell.onboarding.deferred'

function storageKey(organisationId: string, membershipId: string) {
  return `${deferredOnboardingPrefix}:${organisationId}:${membershipId}`
}

export function deferOnboardingForSession(organisationId: string, membershipId: string) {
  window.sessionStorage.setItem(storageKey(organisationId, membershipId), 'true')
}

export function isOnboardingDeferredForSession(organisationId: string, membershipId: string) {
  return window.sessionStorage.getItem(storageKey(organisationId, membershipId)) === 'true'
}

export function clearOnboardingDeferralForSession(organisationId: string, membershipId: string) {
  window.sessionStorage.removeItem(storageKey(organisationId, membershipId))
}
